<div class="resume-check-card">
  <div class="card-body">
    @if (!showTooManyRequestsScreen) {
      <h5>
        {{ 'Common.ResumeSubscriptionProcessTitle' | labelText: productName }}
      </h5>
    }

    @if (showOtpCheck) {
      <app-otp-check
        [prefilledUserId]="userId"
        [prefilledSessionId]="sessionId"
        [showCancel]="false"
        [centerSubmitButton]="true"
        [useAnonymousContactText]="true"
      ></app-otp-check>
    }

    @if (showTooManyRequestsScreen) {
      <div class="request-rate-limit-screen">
        <p class="request-rate-limit-message">{{ tooManyRequestsMessage }}</p>
      </div>
    }

    @if (otpRequestFailed) {
      <p class="resume-check-message">Impossible d'envoyer le code de verification.</p>
    }
  </div>
</div>
